goog.module('yext.storm.account.partner');
goog.module.declareLegacyNamespace();

/**
 * @fileoverview Partner Settings Account page
 *
 * @author nkodali@yext.com
 */

const FieldView = goog.require('yext.fields.FieldView');

function init(partnerIds) {
  var apiKeyFieldView = new FieldView('googlePlacesApiKey');
  apiKeyFieldView.init();

  var emailsFieldView = new FieldView('leadRecipientEmails');
  emailsFieldView.init();

  partnerIds.forEach(function(partnerId) {
    var appInfo = new FieldView('appInfo-' + partnerId);
    appInfo.init();
  });
}

goog.exportSymbol('yext.storm.account.partner.init', init);

exports = {
  init,
};
